import axios from "axios";
const BaseURL = process.env.REACT_APP_API_PATH;

export const addSubscription = (payload) =>
    axios.post(`${BaseURL}/subscription_plan/add_subscription_plan`, payload);

export const updateSubscription = (payload) =>
    axios.put(`${BaseURL}/subscription_plan/update_subscription_by_plan_id`, payload);

export const deleteSubscription = (Stype, Utype) =>
    axios.delete(`${BaseURL}/subscription_plan/deactivate_subscription_plan`, {
        params: { subscriptionType: Stype, userType: Utype }
    });
